// Mirrors `FriendshipStatus` in friends.proto. Numeric values cross Tauri IPC as plain numbers
// (see ChannelType in types/groups.ts for the same convention), so this enum's member order must
// stay in lockstep with the proto.
export enum FriendshipStatus {
  Unknown,
  PendingOutgoing,
  PendingIncoming,
  Accepted,
  Declined,
  Cancelled,
  Removed,
  Blocked,
}

// SignalR friend-event payloads carry the status as a PascalCase C# enum name string instead of
// the proto's numeric code (see friends real-time contract) — this maps one to the other.
export const SIGNALR_FRIENDSHIP_STATUS: Record<string, FriendshipStatus> = {
  PendingOutgoing: FriendshipStatus.PendingOutgoing,
  PendingIncoming: FriendshipStatus.PendingIncoming,
  Accepted: FriendshipStatus.Accepted,
  Declined: FriendshipStatus.Declined,
  Cancelled: FriendshipStatus.Cancelled,
  Removed: FriendshipStatus.Removed,
  Blocked: FriendshipStatus.Blocked,
}

export interface FriendRequest {
  id: string
  other_user_id: string
  other_username: string
  other_display_name: string
  other_avatar_url: string
  status: FriendshipStatus
  message: string
  created_at?: string
}

export interface Friend {
  id: string
  other_user_id: string
  other_username: string
  other_display_name: string
  other_avatar_url: string
  status: FriendshipStatus
  confirmed_at?: string
}

export interface BlockedUser {
  user_id: string
  username: string
  created_at?: string
}

export interface GetFriendsResponse {
  friends: Friend[]
  has_more: boolean
}

export interface GetPendingRequestsResponse {
  requests: FriendRequest[]
  has_more: boolean
}

export interface GetBlockedUsersResponse {
  users: BlockedUser[]
  has_more: boolean
}

export interface FriendshipStatusResponse {
  status: FriendshipStatus
  friend_id?: string
}

// Real-time envelope delivered on the `user-events` SignalR target (see friends real-time
// contract) — not derivable from friends.proto, hand-maintained here.
export type FriendSignalREventType =
  | 'FriendRequestCreated'
  | 'FriendRequestSent'
  | 'FriendRequestAccepted'
  | 'FriendRequestDeclined'
  | 'FriendRequestCancelled'
  | 'FriendRemoved'
  | 'FriendUserBlocked'

export interface FriendSignalREventPayload {
  friendId: string
  otherUserId: string
  otherUsername: string
  otherDisplayName: string | null
  otherAvatarUrl: string
  status: FriendshipStatus
  message: string | null
  timestamp: string
}
